<template>
  <v-row justify="center">
    <v-dialog :value="value" @input="vaciar()" max-width="1000px">
      <v-card>
        <v-card-title>
          <span class="headline">{{localization.titulo}}</span>
        </v-card-title>
        <v-card-text>
          <v-container v-if="!enviado && !mostrarFicheros">
            <v-form v-model="valid" id="valid" ref="form">
              <v-row>
                <v-col cols="12" sm="12">
                    <v-file-input :label="localization.seleccionarArchivoExcel" filled
                    v-model="fichero" id="fichero" prepend-icon="attach_file"
                    accept="application/vnd.ms-excel"
                    :rules="[fichero ? rules.validarFormatoExcel(fichero.type) : null]"
                    truncate-length="100"
                    ></v-file-input>
                </v-col>
              </v-row>
            </v-form>
            <v-row>
              <v-col cols="12" sm="12">
                <v-btn @click="descargaPlantilla()" color="primary" class="mr-2" :disabled="loading">{{localization.plantilla}}</v-btn>
                <v-btn @click="descargaFormato()" color="primary" class="mr-2" :disabled="loading">{{localization.formato}}</v-btn>
                <!-- ver el historico -->
                <v-btn @click="verHistorico()" color="primary" class="mr-2" :disabled="loading">{{localization.verHistorico}}</v-btn>
              </v-col>
            </v-row>
          </v-container>
          <v-container v-if="enviado && !mostrarFicheros">
            <v-tabs
              grow color="primary"
              background-color="transparent"
              class="transparentTabs"
              v-model="summaryTab"
            >
              <v-tab>
              {{localization.documentosNoImportadas}}
              </v-tab>
              <v-tab>
              {{localization.documentosImportadas}}
              </v-tab>

              <v-tab-item>
                <v-container v-show="documentosKO">
                <v-row>
                  <v-data-table :headers="headersKO" :items="listadocumentosKO"
                    item-key="id"  style="width:100%"
                    :footer-props="{
                      'items-per-page-options': [5, 10, 15, 20],
                      'items-per-page-text': $t('filasPorPagina'),
                    }"
                    loading-text="Cargando datos...">
                    <template
                      v-slot:body="{ items }">
                      <tbody>
                        <tr v-for="item in items" :key="item.id">
                          <td width="15%" class="text-xs-center">{{ item.indice }}</td>
                          <td width="20%" class="text-xs-center">{{ item.fila.REFERENCIA }}</td>
                          <td width="15%" class="text-xs-center">{{ item.fila.TIPO_DOCUMENTO }}</td>
                          <td width="20%" class="text-xs-center">{{ item.fila.NOMBRE_DOCUMENTO }}</td>
                          <td width="20%" class="text-xs-center">{{ rellenarMotivos(item) }}</td>
                        </tr>
                      </tbody>
                    </template>
                  </v-data-table>
                  <!-- añadimos texto diciendo que, si hay documentos KO, tiene que corregirlos-->
                  <v-row>
                    <v-col cols="12" sm="12">
                      <v-alert type="error" class="mt-4" v-if="documentosKO">{{localization.corregirDocumentos}}</v-alert>
                    </v-col>
                  </v-row>

                </v-row>
              </v-container>
              </v-tab-item>
              <v-tab-item>
                <v-container v-show="documentosOK">
                  <v-row>
                    <v-data-table :headers="headersOK" :items="listadocumentosOK"
                      item-key="id" style="width:100%"
                      :footer-props="{
                        'items-per-page-options': [5, 10, 15, 20],
                        'items-per-page-text': $t('filasPorPagina'),
                      }"
                      loading-text="Cargando datos...">
                      <template
                        v-slot:body="{ items }">
                        <tbody>
                          <tr v-for="item in items" :key="item.id">
                            <td width="15%" class="text-xs-center">{{ item.indice }}</td>
                            <td width="20%" class="text-xs-center">{{ item.fila.REFERENCIA }}</td>
                            <td width="15%" class="text-xs-center">{{ item.fila.TIPO_DOCUMENTO }}</td>
                            <td width="50%" class="text-xs-center">{{ item.fila.NOMBRE_DOCUMENTO }}</td>
                          </tr>
                        </tbody>
                      </template>
                    </v-data-table>
                    <v-row>
                      <v-col cols="12" sm="12">
                        <v-alert type="success" class="mt-4" v-if="documentosOK && !documentosKO">{{localization.documentosValidos}}</v-alert>
                      </v-col>
                    </v-row>
  
                  </v-row>
                </v-container>
              </v-tab-item>
            </v-tabs>
          </v-container>
          <v-container v-if="enviado && mostrarFicheros">
            <!-- añadimos un input multiple -->
            <v-row>
              <v-col cols="12" sm="12">
                <v-file-input :label="localization.seleccionarArchivos" filled
                v-model="ficheros" id="ficheros" prepend-icon="attach_file"
                multiple
                truncate-length="100"
                ></v-file-input>
              </v-col>
            </v-row>
          </v-container>

        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
            <!--<v-btn color="primary" @click.native="enviado ? $emit('reload') : null; vaciar(); $emit('input');">{{localization.cerrar}}</v-btn>-->
            <v-btn color="primary" @click.native="vaciar(); $emit('input');">{{localization.cerrar}}</v-btn>
            <v-btn color="primary" @click.native="validar()" :disabled="loading" v-if="!enviado">{{localization.validar}}</v-btn>
            <v-btn color="primary" @click.native="mostrarFicheros = true" :disabled="loading" v-if="enviado && !documentosKO && !enviarFicheros">{{localization.confirmar}}</v-btn>
            <v-btn color="primary" @click.native="enviado = false" :disabled="loading" v-if="enviado && documentosKO">{{localization.retry}}</v-btn>
            <v-btn color="primary" @click.native="enviar()" :disabled="loading" v-if="enviado && enviarFicheros">{{localization.enviar}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import { mapActions } from 'vuex'
import moment from 'moment'
import rulesMixin from '@/components/generic/rules.js'

export default {
  mixins: [rulesMixin],
  props: {
    value: Boolean,
    singleItem: Array
  },
  data () {
    return {
      fichero: null,
      enviado: false,
      documentosOK: false,
      documentosKO: false,
      listadocumentosOK: [],
      listadocumentosKO: [],
      informeOK: [],
      informeKO: [],
      loading: false,
      valid: true,
      credentials: {},
      summaryTab: 0,
      ficheros: [],
      mostrarFicheros: false,
      enviarFicheros: false,
      ficherosSend: [],
      plantilla: null
    }
  },
  computed: {
    headersOK () {
      return [
        { text: this.$t('formImportarDocumentos.fila'), sortable: true, value: 'PROMOCIÓN', align: 'center' },
        { text: this.$t('formImportarDocumentos.referencia'), sortable: true, value: 'PROMOCIÓN', align: 'center' },
        { text: this.$t('formImportarDocumentos.tipoDocumento'), value: 'INMUEBLE', sortable: true, align: 'center' },
        { text: this.$t('formImportarDocumentos.nombreDocumento'), value: 'TIPO', sortable: true, align: 'center' }
      ]
    },
    headersKO () {
      return [
        { text: this.$t('formImportarDocumentos.fila'), sortable: true, value: 'PROMOCIÓN', align: 'center' },
        { text: this.$t('formImportarDocumentos.referencia'), sortable: true, value: 'PROMOCIÓN', align: 'center' },
        { text: this.$t('formImportarDocumentos.tipoDocumento'), value: 'INMUEBLE', sortable: true, align: 'center' },
        { text: this.$t('formImportarDocumentos.nombreDocumento'), value: 'TIPO', sortable: true, align: 'center' },
        { text: this.$t('formImportarDocumentos.mensaje'), value: 'TIPO', sortable: true, align: 'center' }
      ]
    },
    localization () {
      return this.$t('formImportarDocumentos')
    },
    usuario() {
      return JSON.parse(localStorage.getItem('usuario'))
    },
  },
  methods: {
    ...mapActions({
      addAlert: 'alerts/add',
      validarImportacionDocumentos: 'incidencias/validarImportacionDocumentos',
      importarDocumentos: 'incidencias/importarDocumentos',
      getRootState: 'gestion/getRootState'
    }),
    descargaPlantilla () {
      location.href = './plantillas/Plantilla-importacion-documentos-Posventa.xls'
    },
    async descargaFormato () {
      const prueba = await this.getRootState()
      this.credentials = prueba
      location.href = './plantillas/Formato-importacion-documentos-Posventa.xlsx'
    },
    formatDate (dateToFormat) {
      return moment(dateToFormat, 'YYYY-MM-DD').format('DD/MM/YYYY')
    },
    mostrarIdiomaEstado (item) {
      var estados = this.$store.state.incidencias.estados
      var estado = estados.find( o => o.name === item) 
      return estado !== undefined ? estado.translates[this.usuario.idioma] : ''
    },
    mostrarIdiomaTipoVisita (item) {
      var tiposVisita = this.$store.state.incidencias.tipoVisita
      var tipoVisita = tiposVisita.find( o => o.name === item || o.code === item) 
      
      return tipoVisita !== undefined ? tipoVisita.translates[this.usuario.idioma] : ''
    },
    validar () {
      this.listadocumentosKO = []
      this.listadocumentosOK = []
      this.documentosKO = false
      this.documentosOK = false
      this.summaryTab = 0
      this.ficheros = []

      this.$refs.form.validate()
      if (!this.valid) {
        this.addAlert({ texto: this.$t('seleccioneArchivoCorrecto'), color: 'error' })
      } else {
        if (this.fichero !== null) {
          try {
            this.loading = true

            var loader = this.$loading.show({
              // Optional parameters
              container: this.fullPage ? null : this.$refs.formContainer,
              canCancel: false
            })

            const file = this.fichero
            const nombreFichero = file.name
            const tipoFichero = file.type
            var reader = new FileReader()
            reader.readAsDataURL(file)
            reader.onload = async () => {
              this.imageBase64 = reader.result
              const arrImageSplit = this.imageBase64.split(',')
              const values = {
                name: nombreFichero,
                type: tipoFichero,
                file_base64: arrImageSplit[1]
              }
              this.plantilla = values
              await this.validarImportacionDocumentos(values)
                .then((response) => {
                  this.enviado = true
                  if (response.documentosOK.length > 0) {
                    this.documentosOK = true
                    this.listadocumentosOK = response.documentosOK
                  }
                  if (response.documentosKO.length > 0) {
                    this.documentosKO = true
                    this.listadocumentosKO = response.documentosKO
                  } else {
                    this.summaryTab = 1
                  }

                  loader.hide()
                  this.loading = false
                })
                .catch((response) => {

                  let mensaje = response.message;
                  this.addAlert({ texto: mensaje, color: 'error' })
                  loader.hide()
                  this.loading = false
                })
            }
          } catch (error) {
            this.addAlert({ texto: this.$t('errorProducido'), color: 'error' })
          }

        }
      }

    },
    vaciar () {
      this.fichero = null
      this.enviado = false
      this.documentosOK = false
      this.documentosKO = false
      this.listadocumentosOK = []
      this.listadocumentosKO = []
      this.summaryTab = 0
      
      this.mostrarFicheros = false
      this.enviarFicheros = false
      this.ficherosSend = []
      this.ficheros = []

      this.$emit('input')
    },
    rellenarMotivos(item) {
      let motivos = ''
      item.error.forEach((error, index) => {
        motivos += error.motivo
        if (index < item.error.length - 1) {
          motivos += ', '
        }
      })
      return motivos
    },
    enviar() {
      this.listadocumentosKO = []
      this.listadocumentosOK = []
      this.documentosKO = false
      this.documentosOK = false
      this.summaryTab = 0
      
      if (this.ficheros !== null) {
        try {
          this.loading = true

          var loader = this.$loading.show({
            // Optional parameters
            container: this.fullPage ? null : this.$refs.formContainer,
            canCancel: false
          })

          this.ficheros.forEach(async fichero => {
            const file = fichero
            const nombreFichero = file.name
            const tipoFichero = file.type
            var reader = new FileReader()
            reader.readAsDataURL(file)
            reader.onload = async () => {
              this.imageBase64 = reader.result
              const arrImageSplit = this.imageBase64.split(',')
              const values = {
                name: nombreFichero,
                type: tipoFichero,
                file_base64: arrImageSplit[1]
              }
              this.ficherosSend.push(values)

              if (this.ficherosSend.length === this.ficheros.length) {
                // enviamos los ficheros

                const params = {
                  "documentos": this.ficherosSend,
                  "plantilla": this.plantilla
                }

                await this.importarDocumentos(params)
                  .then((response) => {
                    console.log(response)
                    this.enviado = true
                    this.vaciar()
                    this.addAlert({ texto: 'Documentos importados correctamente.', color: 'success' })
                    this.loading = false
                  })
                  .catch((response) => {
                    console.log(response)
                    let mensaje = response.message;
                    this.addAlert({ texto: mensaje, color: 'error' })
                    loader.hide()
                    this.loading = false
                  })
              }

            }
          })

          loader.hide()
          /*
          
            await this.validarImportacionDocumentos(values)
              .then((response) => {
                this.enviado = true
                if (response.documentosOK.length > 0) {
                  this.documentosOK = true
                  this.listadocumentosOK = response.documentosOK
                }
                if (response.documentosKO.length > 0) {
                  this.documentosKO = true
                  this.listadocumentosKO = response.documentosKO
                } else {
                  this.summaryTab = 1
                }

                loader.hide()
                this.loading = false
              })
              .catch((response) => {

                let mensaje = response.message;
                this.addAlert({ texto: mensaje, color: 'error' })
                loader.hide()
                this.loading = false
              })
          }
          */
        } catch (error) {
          console.log(error)
          this.addAlert({ texto: this.$t('errorProducido'), color: 'error' })
        }

      }
    },
    verHistorico() {
      this.$emit('verHistorico')
    }
  },
  watch: {
    ficheros (val) {
      // comprobamos que haya tantos ficheros como documentosOK
      // comprobamos que los nombres de los ficheros sean los mismos que documentosOK
      let contador = 0
      let ficherosNoValidos = ''
      if (val.length == 0) return

      if(val.length != this.listadocumentosOK.length) { 
        this.addAlert({ texto: this.$t('formImportarDocumentos.errorFicheros') + ' ' + this.$t('formImportarDocumentos.errorFicherosCantidad'), color: 'error' })
        return
      }

      val.forEach((fichero) => {
        // cada fichero, comprobamos si está en documentosOK.filas.NOMBREFICHERO
        let documento = this.listadocumentosOK.find( o => o.fila.NOMBRE_DOCUMENTO === fichero.name)
        if(documento) {
          contador ++
        } else {
          ficherosNoValidos += fichero.name + ', '
        }
      })
      if (contador === this.listadocumentosOK.length) {
        // todo ok
        // habilitamos el botón de subir ficheros
        this.enviarFicheros = true
      } else {
        this.addAlert({ texto: this.$t('formImportarDocumentos.errorFicheros') + ': ' + ficherosNoValidos, color: 'error' })
      }
    }
  }
}
</script>

<style scoped>

</style>
